<template lang="pug">
  .cashback-header
    .header-left
      span.header-title {{ moduleName }}
      span.header-rebate(
        v-if="mainText"
        @click="handleUseGuideClick"
      ) {{ mainText }}
    .header-right(@click="handleOrderClick")
      span.order-text {{ subText }}
      img.order-arrow(
        src="https://m.hellobike.com/15e7879a35.png"
        alt=""
      )
</template>

<script>
import { jumpUrl } from '@/utils/tools';
import config from '@/const/config';

export default {
  name: 'CashbackHeader',
  props: {
    moduleName: {
      type: String,
      default: '电商购物返奖励金',
    },
    mainText: {
      type: String,
      default: '返币订单',
    },
    subText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mobileEnv: config.env === 'dev' ? 'fat' : config.env,
    };
  },
  methods: {
    handleOrderClick() {
      const url = `https://m.hellobike.com/AppCommercialH5/${
        this.mobileEnv !== 'pro' ? `${this.mobileEnv}/` : ''
      }latest/index.html#/myorder?scene=rebateBonus`;
      jumpUrl(url);
    },
    handleUseGuideClick() {
      jumpUrl(
        'https://m.hellobike.com/mf/spa/u_xkyjzd/latest/MA2504087308769061950390860.html?activityCode=MA2504087308769061950390860',
      );
    },
  },
};
</script>

<style lang="less" scoped>
.cashback-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.1rem;

  .header-left {
    display: flex;
    align-items: center;
    height: 0.2rem;

    .header-title {
      font-size: 0.15rem;
      font-weight: 600;
      color: #242729;
      line-height: 0.16rem;
      height: 0.16rem;
    }

    .header-rebate {
      font-size: 0.11rem;
      color: #ff6200;
      background-color: #fff5eb;
      height: 0.18rem;
      line-height: 0.18rem;
      border-radius: 0.09rem;
      padding: 0 0.06rem;
      display: flex;
      align-items: center;
      margin-left: 0.06rem;

      &::after {
        content: '';
        display: inline-block;
        width: 0.1rem;
        height: 0.1rem;
        margin-left: 0.02rem;
        background-image: url('https://m.hellobike.com/49d393a73c.png');
        background-size: cover;
        background-position: center;
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    .order-text {
      font-size: 0.12rem;
      color: #879099;
    }

    .order-arrow {
      width: 0.12rem;
      height: 0.12rem;
    }
  }
}
</style>
